import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export type ProductBrandingScope = 'product' | 'tenant';

export interface ProductBrandingRow {
  id: number;
  scope: ProductBrandingScope;
  product_id: number | null;
  tenant_id: number | null;
  logo_url: string | null;
  theme_colour: string;
  display_name: string | null;
  notes: string | null;
  updated_by: number | null;
  updated_at: string;
  reference_name: string;
}

export interface ResolvedProductBranding {
  logoUrl: string | null;
  themeColour: string;
  displayName: string | null;
  source: 'tenant' | 'product' | 'global';
}

export interface ProductBrandingFormPayload {
  logo_url?: string;
  theme_colour: string;
  display_name?: string;
  notes?: string;
}

const list = () => http.get(API_ENDPOINTS.productBranding);

/** Pass tenantId to resolve tenant-scope branding first (US-056), falling back to product, then global. */
const getForProduct = (productId: number | string, tenantId?: number | string) =>
  http.get(`${API_ENDPOINTS.masterProducts}/${productId}/branding${tenantId ? `?tenantId=${tenantId}` : ''}`);

const upsert = (productId: number | string, payload: ProductBrandingFormPayload) =>
  http.put(`${API_ENDPOINTS.masterProducts}/${productId}/branding`, payload);

const upsertForTenant = (tenantId: number | string, payload: ProductBrandingFormPayload) =>
  http.put(`${API_ENDPOINTS.tenants}/${tenantId}/branding`, payload);

const uploadLogo = (file: File) => {
  const formData = new FormData();
  formData.append('logo', file);
  return http.post(API_ENDPOINTS.productBrandingLogoUpload, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const ProductBrandingService = { list, getForProduct, upsert, upsertForTenant, uploadLogo };

export default ProductBrandingService;
